import { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { Box, CircularProgress, Typography } from '@mui/material';

import { useTheme } from 'themes/themeProvider';
import { Currency, ThemeKey } from 'types/general.types';

import { ReactComponent as CalendarIcon } from 'assets/icons/CalendarIcon.svg';

import { TOOLTIP_MESSAGES } from 'constants/notifications';
import { FaCircleInfo } from 'react-icons/fa6';
import { TooltipIcon } from 'shared/TooltipIcon';
import { pendingLifetimeInfoSelector, userBaseCurrencySelector, userDataSelector } from 'store/slices/user-slice';
import classes from './BalanceCard.module.scss';

type Props = {
  actionElement?: ReactNode;
  testId?: string;
  isLoading?: boolean;
};

export const BTCBalanceCard = ({ actionElement, isLoading, testId = 'btc-balance-card' }: Props) => {
  const { theme, themeKey } = useTheme();
  const baseCurrency = useSelector(userBaseCurrencySelector) ?? Currency.USD;

  const user = useSelector(userDataSelector);

  const { lifetimeEarningsAmount, lifetimeEarningsCoins, pendingPoolBalanceAmount, pendingPoolBalanceCoins } =
    useSelector(pendingLifetimeInfoSelector) || {
      lifetimeEarningsAmount: 0,
      lifetimeEarningsCoins: 0,
      pendingPoolBalanceAmount: 0,
      pendingPoolBalanceCoins: 0,
    };

  const btcIconClassName = themeKey === ThemeKey.CHRONOS_ENERGY ? classes.btcIconDark : classes.btcIcon;

  return (
    <Box data-testid={testId} height='100%' minHeight={210} display='flex' flexDirection='column'>
      {isLoading ? (
        <div className={classes.loaderContainer}>
          <CircularProgress className={classes.loader} size={24} sx={{ color: theme.widgets.fiatWallet.textColor }} />
        </div>
      ) : (
        <>
          <Box display='flex' justifyContent='center' alignItems='center'>
            {/* <BTCIcon /> */}
            <Typography variant='body1' textAlign='center' display='block' mr={1}>
              {/* BTC Wallet */}
              Estimated mining days
            </Typography>
            <TooltipIcon
              icon={<FaCircleInfo color={theme.widgets.bitcoinWallet.textColor} />}
              tooltipId='EstimatedMiningDays'
              tooltipText={TOOLTIP_MESSAGES.ESTIMATED_MINING_DAYS}
            />
          </Box>

          {/* <Box display='flex' flexDirection='column' my={1} mt={2}>
            <Box display='flex' alignItems='center'>
              <Box>
                <Typography variant='caption' mr={1}>
                  Pending pool balance
                </Typography>
                <TooltipIcon
                  icon={<FaCircleInfo color={theme.widgets.bitcoinWallet.textColor} />}
                  tooltipId='Pending pool balance'
                  tooltipText={TOOLTIP_MESSAGES.BALANCE}
                />
              </Box>
            </Box>
            <Box className={classes.valuesContainer}>
              <Typography variant='h3'>
                <BTCIconPure className={btcIconClassName} />
                {getBalance('1', pendingPoolBalanceCoins, Currency.BTC)}
              </Typography>
            </Box>
            <span className={classes.subBalance}>{formatCurrency(baseCurrency, pendingPoolBalanceAmount)}</span>
          </Box>

          <Box display='flex' flexDirection='column' my={1}>
            <Box display='flex' alignItems='center'>
              <Typography variant='caption' mr={1}>
                Lifetime earnings
              </Typography>
              <TooltipIcon
                icon={<FaCircleInfo color={theme.widgets.bitcoinWallet.textColor} />}
                tooltipId='Lifetime earnings'
                tooltipText={TOOLTIP_MESSAGES.EARNINGS}
              />
            </Box>
            <Box className={classes.valuesContainer}>
              <Typography variant='h3'>
                <BTCIconPure className={btcIconClassName} />
                {getBalance('1', lifetimeEarningsCoins, Currency.BTC)}
              </Typography>
            </Box>
            <span className={classes.subBalance}>{formatCurrency(baseCurrency, lifetimeEarningsAmount)}</span>
          </Box> */}

          <Box display='flex' justifyContent='center' alignItems='center' flexGrow={1} width='100%'>
            <Typography variant='h3' />
            <Box display='flex' flexDirection='column' alignItems={'center'}>
              <CalendarIcon color={theme.widgets.bitcoinWallet.textColor} />
              <Typography variant='h3' my={1}>
                {Math.floor(Math.max(user?.balance || 0, 0) / (user?.yesterdayTotalElectricityCost || 1))}{' '}
              </Typography>
              <Typography variant='caption'>days</Typography>
            </Box>
          </Box>

          <Box display='flex' justifyContent='center' alignItems='center' mt='auto'>
            {actionElement}
          </Box>
        </>
      )}
    </Box>
  );
};
